import { initListingAutocomplete } from '../shared/listing-autocomplete';

/**
 * The suggestions of the parcel search of „Znajdź działkę”
 * (views/guided-check/_parcel_search_forms.php), on the find page
 * (find-page.js) and in the start dialog of the map
 * (newmobilemap/modules/start-dialog.js): places for the place field and
 * addresses for the address field, each list found by the `aria-controls` of
 * its field. A place or an address chosen from a list goes with the search
 * as its key until its text changes; a chosen address sends its form at once
 * through `submit(form)`, by default `requestSubmit()`. Every text comes from
 * `texts` (GuidedCheckPage::searchTexts()); the forms work without this script.
 */

var PLACE_MIN_LENGTH = 2;
var ADDRESS_MIN_LENGTH = 3;

function listOf(input) {
    var id = input.getAttribute('aria-controls') || '';
    return id ? input.ownerDocument.getElementById(id) : null;
}

// requestSubmit() sends the form as its button would, with a submit event.
function sendForm(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
}

// The list of one field, with what the two lists share.
function suggestions(input, url, options) {
    return initListingAutocomplete(Object.assign({
        input: input,
        results: listOf(input),
        url: url || '',
        params: function(query) { return { q: query }; },
        label: function(item) { return String(item.label || ''); },
        meta: function(item) { return String(item.meta || ''); },
        optionClass: 'ms-menu__item',
        messageClass: 'ms-menu__message',
        enterSubmits: true,
    }, options)) || null;
}

/**
 * @param {{placeInput: ?Element, placeKey: ?Element, addressInput: ?Element, addressId: ?Element, addressForm: ?Element,
 *     placesUrl: string, addressesUrl: string, texts: ?Object, submit: ?function(Element)}} options
 * @return {{place: ?{close: function()}, address: ?{close: function()}}}
 */
export function initParcelSearch(options) {
    var texts = options.texts || {};
    var submit = options.submit || sendForm;
    var placeInput = options.placeInput;
    var placeKey = options.placeKey;
    var addressInput = options.addressInput;
    var addressId = options.addressId;
    var addressForm = options.addressForm;
    var search = { place: null, address: null };

    if (placeInput && placeKey) {
        // A typed name is searched by name: a chosen place stays chosen only until the text changes.
        placeInput.addEventListener('input', function() { placeKey.value = ''; });
        search.place = suggestions(placeInput, options.placesUrl, {
            onSelect: function(item) {
                placeInput.value = String(item.label || '');
                placeKey.value = String(item.key || '');
            },
            minLength: PLACE_MIN_LENGTH,
            loading: texts.placesLoading,
            empty: texts.placesEmpty,
            error: texts.placesError,
        });
    }

    if (addressInput && addressId && addressForm) {
        addressInput.addEventListener('input', function() { addressId.value = ''; });
        search.address = suggestions(addressInput, options.addressesUrl, {
            // A chosen address is the whole question: the parcel under it is shown at once.
            onSelect: function(item) {
                addressInput.value = String(item.label || '');
                addressId.value = String(item.id || '');
                submit(addressForm);
            },
            minLength: ADDRESS_MIN_LENGTH,
            loading: texts.addressesLoading,
            empty: texts.addressesEmpty,
            error: texts.addressesError,
        });
    }

    return search;
}
